import React, { FC } from 'react';

import { BaseStyleEnums, CoreUtils } from '@nhl/nhl-breakaway-ui';

import { useSizeWithThrottle } from '~/core/hooks/useSizeWithThrottle';

import GameRecap from '../../../../components/gameRecap/GameRecap';
import Highlights from '../../../../components/highlights/Highlights';
import IceSheet from '../../../../components/iceSheet/IceSheet';
import Penalties from '../../../../components/penalties/Penalties';
import ScoringSummary from '../../../../components/scoringSummary/ScoringSummary';
import ThreeStars from '../../../../components/threeStars/ThreeStars';
import { GameCenterViewType } from '../../../../enums';
import { SectionContainer } from '../../../../styles';
import { LandingGame } from '../../../../types';
import GameCenterLoader from '../../../gameCenterLoader/GameCenterLoader';
import RightRail from '../../../rightRail/RightRail';

import { MainContentContainer, SummaryGameContainer } from './styles';

type SummaryProps = {
    game: LandingGame;
    gameId?: number;
    isInitialLoad: boolean;
};

const Summary: FC<SummaryProps> = ({ game, gameId, isInitialLoad }) => {
    const screenSize = useSizeWithThrottle();
    const isLiveGame = CoreUtils.isGameLive(game.gameState);
    const isLarge = screenSize.width >= BaseStyleEnums.ScreenWidthBreakpoints.large;

    const content = isLiveGame ? (
        <GameCenterLoader isInitialLoad={isInitialLoad}>
            <IceSheet game={game} />
            <ScoringSummary game={game} isLarge={isLarge} />
            <Penalties game={game} />
        </GameCenterLoader>
    ) : (
        <GameCenterLoader isInitialLoad={isInitialLoad}>
            <GameRecap gameId={gameId} />
            <ScoringSummary game={game} isLarge={isLarge} />
            <Highlights game={game} />
            <Penalties game={game} />
            <ThreeStars game={game} />
        </GameCenterLoader>
    );

    return isLarge ? (
        <SectionContainer
            id={`${GameCenterViewType.SUMMARY}-tabpanel`}
            role="tabpanel"
            aria-labelledby={GameCenterViewType.SUMMARY}
        >
            <MainContentContainer>{content}</MainContentContainer>
            <RightRail />
        </SectionContainer>
    ) : (
        <SummaryGameContainer
            id={`${GameCenterViewType.SUMMARY}-tabpanel`}
            role="tabpanel"
            aria-labelledby={GameCenterViewType.SUMMARY}
            $commonGameDetails={game}
        >
            {content}
            <RightRail />
        </SummaryGameContainer>
    );
};

export default Summary;
